export function generateColors(numColors: number): string[] {
  const colors = [];
  const minBlue = 100; 
  const maxBlue = 255; 

  for (let i = 0; i < numColors; i++) {
      const blue = Math.floor(Math.random() * (maxBlue - minBlue + 1)) + minBlue;
      
      const color = `rgb(13, 90, ${blue})`; 
      colors.push(color);
  }

  return colors;
}
